<script setup lang="ts">
import { useUpdateCanvass } from "./canvassesCrud";
import CanvassForm from "./CanvassForm.vue";
import type { Canvass } from "./types";

defineProps<{
  canvass: Canvass;
}>();

const {
  updateCanvass,
  updateCanvassStatus,
  error: updateCanvassError,
} = useUpdateCanvass();
</script>

<template>
  <CanvassForm
    v-if="canvass !== undefined"
    :canvass="canvass"
    :updating-status="updateCanvassStatus"
    :error="updateCanvassError"
    @update="updateCanvass"
  />
</template>
